"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Programs = void 0;
var Programs;
(function (Programs) {
    Programs["DEKALB_INTEGRADO"] = "dekalb-integrado";
    Programs["FIELDVIEW_ADVISOR"] = "fieldview-advisor";
    Programs["PRECEON"] = "preceon";
    Programs["VALORA"] = "valora";
})(Programs || (exports.Programs = Programs = {}));
